import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Grid } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { ExpandableContainer } from '../../ExpandableContainer/ExpandableContainer';
import { ActionCardHeader } from '../../Customer/ActionCardHeader';
import { CardSection } from '../CardSection';
import { DateFormat } from '../../Format/DateTimeFormat';

const BoardMemberList = ({ boardMemberNames }) => {
  return (
    <List dense={true} disablePadding>
      {boardMemberNames.map(name => (
        <ListItem key={name} disablePadding>
          <ListItemText primary={name} />
        </ListItem>
      ))}
    </List>
  );
};

BoardMemberList.propTypes = {
  boardMemberNames: PropTypes.arrayOf(PropTypes.string),
};

export const ApproverVerificationCard = ({ action }) => {
  const { t } = useTranslation();
  const type = action.type;
  const reason = action.reason;
  const details = action.details;
  const approverName = details?.approver?.name;
  const authSignText = details?.authSignText;
  let boardMembers = '-';
  if (!isEmpty(details?.boardMembers)) {
    boardMembers = <BoardMemberList boardMemberNames={details.boardMembers.map(member => member.name)} />;
  }

  return (
    <ExpandableContainer
      header={
        <ActionCardHeader status={action.status} headerText={type ? t(`enums.sessionActionType.${type}`, type) : '?'} />
      }
      sx={{ mb: 2 }}
    >
      <Grid container>
        <CardSection title={t('components.cards.defaultSessionAction.createdDate')}>
          <DateFormat date={action.createdDate} />
        </CardSection>
        <CardSection title={t('components.cards.approverVerification.boardMembers')} size="m">
          {!isEmpty(boardMembers) ? boardMembers : '-'}
        </CardSection>
        <CardSection title={t('enums.sessionActionReason.name')}>
          {reason ? t(`enums.sessionActionReason.values.${reason}`, reason) : '-'}
        </CardSection>
        <CardSection title={t('components.cards.approverVerification.authSigns')} size="m">
          {authSignText ? authSignText : '-'}
        </CardSection>
        <CardSection title={t('components.cards.approverVerification.approverName')} size="m">
          {approverName ? approverName : '-'}
        </CardSection>
      </Grid>
    </ExpandableContainer>
  );
};

ApproverVerificationCard.propTypes = {
  action: PropTypes.shape({
    status: PropTypes.string,
    reason: PropTypes.string,
    type: PropTypes.string,
    createdDate: PropTypes.string,
    details: PropTypes.shape({
      approver: PropTypes.object,
      boardMembers: PropTypes.arrayOf(PropTypes.object),
      authSignText: PropTypes.string,
    }),
  }),
};
